export default "__VITE_ASSET__rfOeM33l__"